/* eslint-disable react/jsx-fragments */
import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {i18n} from '@src/i18n';

import {connect, useSelector} from 'react-redux';
import {
  getProfileId,
  getOrganisationId,
  getMessageUnreadCount, getProfile,
} from '@selectors/profile.selectors';
import {getRouteWithParams} from '@utils/routes.utils';
import {css} from '@emotion/react';
import {
  employees as employeeRoutes,
  myEducation,
} from '@routes/routes.manifest';
import {withRouter, matchPath} from 'react-router';
import {
  getIsMobile,
  getIsMobileCourseCatalog,
} from '@selectors/global.selectors';
import {
  getConfigObject,
  getPropertiesForCurrLangAndTrack,
} from '@selectors/config.selectors';
import {getSelectedCompetencegroupId} from '@selectors/courses.selectors';
import MobileMenu from './mobile-menu/mobile-menu';
import DesktopMenu from './desktop-menu/desktop-menu';

import {rotor} from './rotor';
import {appTitle} from '@config';

export const getColorConfigForGroup = ({
  courseGroupId,
  pathname,
  isMobile,
  configObject,
  forMenu,
}) => {
  const defaultColor
    = configObject.getProperty(`params.menu.${isMobile ? 'baseColorMobile' : 'baseColorDesktop'}`) || 'rgb(1, 0, 49)';

  if (forMenu) {
    return {
      color: defaultColor,
      createGradient: false,
    };
  }


  if (!isMobile) {
    return {
      color: configObject.getProperty('params.menu.baseColorDesktop'),
      createGradient: false,
    };
  }
  const noActiveCourseGroup
    = isMobile && pathname === '/course-catalog'
    || !isMobile && !courseGroupId
    || pathname === '/atlas';

  if (noActiveCourseGroup) {
    return {
      color: defaultColor,
      createGradient: false,
    };
  }

  return {
    color:
      configObject.getProperty(`params.menu.configByCourseGroupId.${courseGroupId}.baseColor`) || defaultColor,
    createGradient:
      configObject.getProperty(`params.menu.configByCourseGroupId.${courseGroupId}.gradient`) || false,
  };
};

const Menu = ({
  onLogoutClick,
  isManager,
  isMobile,
  orgId,
  personId,
  profileData,
  messagesCount,
  location,
}) => {
  const [isMobileMenuOpened, setMobileMenuOpened] = useState(false);

  const configObject = useSelector(getConfigObject);
  const menuConfig = configObject.getProperty('params.menu') || {};
  const selectedCourseGroupId = useSelector(getSelectedCompetencegroupId);
  const isMobileCourseCatalog = useSelector(getIsMobileCourseCatalog);

  const toggleSidebarMenu = () => {
    setMobileMenuOpened(!isMobileMenuOpened);
  };

  const messagesCountString = messagesCount && ` (${messagesCount})` || '';
  const baseTitle
    = configObject.getProperty('params.default-title-key')
    && i18n(configObject.getProperty('params.default-title-key'));
  const menuLinksManager = [
    {
      name: i18n('menu.my-page'),
      title: i18n('menu.my-page'),
      path: '/my-education',
      active: matchPath(location.pathname, {
        path: '/my-education',
        exact: false,
      }),
      children: [
        {
          name: `Meldinger${messagesCountString}`,
          title: 'Meldinger - Min Side',
          path: getRouteWithParams(myEducation.messagesView.path, {personId}),
          active: matchPath(location.pathname, {
            path: myEducation.messagesView.active,
            exact: false,
          }),
        },
        {
          name: 'Gjennomført opplæring',
          title: 'Gjennomført opplæring - Min Side',
          path: getRouteWithParams(myEducation.cvView.path, {personId}),
          active: matchPath(location.pathname, {
            path: myEducation.cvView.active,
            exact: false,
          }),
        },
      ],
    },
    {
      name: i18n('menu.course-catalog'),
      title: `${i18n('menu.course-catalog')}${
        baseTitle && ` - ${baseTitle}` || ''
      }`,
      path: '/course-catalog',
      active: matchPath(location.pathname, {
        path: '/course-catalog',
        exact: false,
      }),
    },
    {
      name: i18n('menu.dashboard'),
      title: i18n('menu.dashboard'),
      path: getRouteWithParams(employeeRoutes.dashboard, {orgId}),
      active: matchPath(location.pathname, {
        path: '/dashboard',
        exact: false,
      }),
    },
    {
      name: i18n('menu.employees'),
      title: i18n('menu.employees'),
      path: getRouteWithParams(employeeRoutes.employees, {orgId}),
      active: matchPath(location.pathname, {
        path: '/employees',
        exact: false,
      }),
    },
  ];

  const menuLinksEmployee = [
    {
      name:i18n('menu.my-page'),
      path: '/my-education',
      active: matchPath(location.pathname, {
        path: '/my-education',
        exact: false,
      }),
      children: [
        {
          name: `Meldinger${messagesCountString}`,
          path: getRouteWithParams(myEducation.messagesView.path, {personId}),
          active: matchPath(location.pathname, {
            path: myEducation.messagesView.active,
            exact: false,
          }),
        },
        {
          name: 'Gjennomført opplæring',
          path: getRouteWithParams(myEducation.cvView.path, {personId}),
          active: matchPath(location.pathname, {
            path: myEducation.cvView.active,
            exact: false,
          }),
        },
      ],
    },
    {
      name: i18n('menu.course-catalog'),
      path: '/course-catalog',
      active: matchPath(location.pathname, {
        path: '/course-catalog',
        exact: false,
      }),
    },
  ];

  const menuLinks = isManager ? menuLinksManager : menuLinksEmployee;

  const setDocumentTitle = links =>
    links
      && links.map(({title, active, children}) => {
        if (active && title) {
          document.title = title + (appTitle ? ` - ${appTitle}` : '');
        }

        return setDocumentTitle(children);
      })
    ;

  setDocumentTitle(menuLinksManager);

  const colorConfigForGroup = getColorConfigForGroup({
    courseGroupId: selectedCourseGroupId,
    pathname: location.pathname,
    isMobile: isMobileCourseCatalog,
    configObject,
    forMenu: true,
  });

  const useMap = configObject.isMapActivated;
  const configForCurrentMap = useSelector(getPropertiesForCurrLangAndTrack);

  return (
    <div
      css={css`
        display: contents;
      `}
    >
      {menuConfig && menuConfig.type === 'menu-two' || !menuConfig.type
        ? rotor({
          onLogoutClick,
          ...menuConfig,
          ...useMap ? configForCurrentMap.menu || {} : {},
          variant: isMobile ? 'hamburger' : 'horizontal',
          createGradient: colorConfigForGroup.createGradient,
          baseColor: colorConfigForGroup.color,
        }).menuTwo
        : (
          <DesktopMenu
            orgId={orgId}
            data={!profileData
              ? {}
              : {
                profile: {
                  displayName: profileData.fullname,
                  items: [
                    {
                      label: i18n('person.menu.competences'),
                      subLabel: i18n('person.menu.competencesTxt'),
                      href: getRouteWithParams(myEducation.cvView.path, {personId: profileData.id}),
                      type: 'featureLink',
                    },
                    {
                      label: i18n('person.menu.profile'),
                      subLabel: i18n('person.menu.profileTxt'),
                      href: getRouteWithParams(myEducation.profileView.path, {personId: profileData.id}),
                      type: 'featureLink',
                    },
                    {
                      label: i18n('person.menu.messages'),
                      subLabel: i18n('person.menu.messagesTxt'),
                      href: getRouteWithParams(myEducation.messagesView.path, {personId: profileData.id}),
                      type: 'featureLink',
                    },

                    {type: 'separator'},
                    {
                      label: i18n('person.menu.logout'),
                      subLabel: i18n('person.menu.logoutTxt'),
                      href: '/logout',
                      type: 'featureLink',
                    },
                  ],
                },
              }}
            menuLinks={menuLinks}
            onLogoutClick={onLogoutClick}
          />
        )}
    </div>
  );
};

Menu.propTypes = {
  onLogoutClick: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
  isManager: PropTypes.bool.isRequired,
  profileData: PropTypes.shape({}),
  orgId: PropTypes.number.isRequired,
  personId: PropTypes.number.isRequired,
  messagesCount: PropTypes.number.isRequired,
  location: PropTypes.shape({pathname: PropTypes.string.isRequired}).isRequired,
};

Menu.defaultProps = {profileData: null};

const mapStateToProps = state => ({
  orgId: getOrganisationId(state),
  personId: getProfileId(state),
  messagesCount: getMessageUnreadCount(state),
  isMobile: getIsMobile(state),
});

export default withRouter(connect(mapStateToProps)(Menu));
